"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalAuthContext = void 0;
exports.globalAuthContext = {
    state: null,
    set: (newState) => {
        exports.globalAuthContext.state = Object.assign(Object.assign({}, exports.globalAuthContext.state), newState);
    }
};
